/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Email_P1Inputs */

const en_contact_email_p1 = /** @type {(inputs: Contact_Email_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For general questions, feedback, or partnership inquiries, email me directly. I read every message and usually reply within a couple of business days.`)
};

const ko_contact_email_p1 = /** @type {(inputs: Contact_Email_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일반적인 문의, 피드백, 제휴 제안은 아래 주소로 직접 메일을 보내주세요. 모든 메일을 읽고 보통 영업일 이틀 안에 답장합니다.`)
};

const ja_contact_email_p1 = /** @type {(inputs: Contact_Email_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的なご質問、フィードバック、提携のご相談は下記アドレスへ直接メールしてください。すべて読んでおり、通常は 2 営業日ほどで返信します。`)
};

/**
* | output |
* | --- |
* | "For general questions, feedback, or partnership inquiries, email me directly. I read every message and usually reply within a couple of business days." |
*
* @param {Contact_Email_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_email_p1 = /** @type {((inputs?: Contact_Email_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Email_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_email_p1(inputs)
	if (locale === "ko") return ko_contact_email_p1(inputs)
	return ja_contact_email_p1(inputs)
});